<template>
  <v-card class="my-4" v-if="progress && progress.length">
    <v-toolbar color="primary" flat dark>
      <v-toolbar-title>Percentage class completion</v-toolbar-title>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="progress"
      class="completed_lesson_table"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:body="{ items }">
        <template v-for="(item, i) in items">
          <tr
            v-for="(row, index) in item.lessons"
            :key="`${item.classId}-${index}`"
            :class="[i % 2 === 0 ? 'row-even' : 'row-odd']"
          >
            <td
              class="right-border"
              v-if="index === 0"
              :rowspan="item.lessons.length"
            >
              {{ item.class }}
            </td>
            <td class="text-center">{{ row.lesson }}</td>
            <td class="text-center">{{ row.classProgress }}%</td>
            <td class="text-center justify-center row no-gutters">
              <v-btn
                text
                color="primary"
                :to="
                  `/teacher/dashboard/classes?currentClassId=${item.classId}&currentParentTab=students&currentChildTab=0&uncompletedLesson=${row.lesson}`
                "
              >
                View incomplete student {{ lessonTerm }}s
                <v-icon right dark>arrow_right_alt</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LessonCompleted',
  async mounted() {
    this.progress = await this.$axios.get(
      'api/teachers/reports?type=percentageClassCompletionByTeacher&date_start=20-01-01&date_end=2030-01-01'
    )
  },
  data() {
    return {
      progress: null
    }
  },
  computed: {
    ...mapState(['lessonTerm']),
    headers() {
      return [
        {
          text: 'Class',
          align: 'left',
          sortable: false
        },
        {
          text: `${this.capitalizeFirstLetter(this.lessonTerm)}`,
          align: 'center',
          sortable: false
        },
        {
          text: 'Progress',
          align: 'center',
          sortable: false
        },
        {
          text: 'Action',
          align: 'center',
          sortable: false
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.completed_lesson_table {
  tr:hover {
    background-color: white !important;
  }

  tr {
    &.row-even {
      background: #eee;

      &:hover {
        background-color: #eee !important;
      }
    }
  }

  td.right-border {
    border-right: 1px solid rgba(0, 0, 0, 0.12);
  }
}
</style>
